
import React from 'react';

const BookingHeader: React.FC = () => {
  return (
    <section className="bg-itmgmt-dark-blue text-white py-16 md:py-20">
      <div className="container-wide">
        <div className="text-center">
          <h1 className="heading-xl mb-6">
            Book a Free Consultation
          </h1>
          <p className="text-xl max-w-3xl mx-auto mb-8 text-gray-300">
            Schedule a no-obligation consultation to discuss your IT needs and 
            discover how we can help your business thrive.
          </p>
        </div>
      </div>
    </section>
  );
};

export default BookingHeader;
